// extracted by mini-css-extract-plugin
export default {"root":"_2n_U_","message":"_3AnzU","button":"_17US3"};